module.exports = __webpack_public_path__ + "static/illustration-footer-d-c83b9c2a2024af8de0a8518921eeb684.svg";